<template>
  <div class="relative">
    <component :is="listingURL?'a':'span'" class="no-underline text-black" :href="listingURL">
      <div v-if="tagline" class="absolute right-0 top-0 bg-kwred py-2 px-4 text-white font-semibold  uppercase ">
        {{ getTagline }}
      </div>

      <img :src="imageURL" class="w-full" >

      <div class="absolute sm:static bottom-0 left-0 right-0 text-white sm:text-black bg-fade sm:bg-fade-none p-4 sm:p-0 pt-16 sm:pt-4 text-shadow sm:text-shadow-none">
        <div class="font-bold text-2xl mb-2 flex flex-row items-center">
          {{ getPrice }}
          <span v-if="note" class="text-base uppercase text-white sm:text-kwmaingray text-right flex-1">{{ note }}</span>
        </div>
        <div v-id="address" class="text-xl leading-tight">
          {{ address }}
        </div>
        <div class="text-lg mt-2 text-kwdarkgray">
          <template v-if="closingDate">
            {{ closingDate }}
            <span v-if="closingNote">{{ closingNote }}</span>
          </template>
          <template v-else>
            {{ beds }} beds
            <span class="text-gray-500">•</span>
            {{ baths }} baths
            <span v-if="getSqft" class="text-gray-500">•</span>
            {{ getSqft }}
          </template>
        </div>
      </div>
    </component>
  </div>
</template>

<script>

export default {
  name: 'PropertyCard',
  props: {
    address: {
      type: String
      // required: true
    },
    price: {
      type: Number,
      required: true
    },
    beds: {
      type: Number
    },
    baths: {
      type: Number
    },
    sqft: {
      type: Number
    },
    imageURL: {
      type: String
      // required: true
    },
    tagline: {
      type: String
    },
    listingURL: {
      type: String
    },
    closingDate: {
      type: String
    },
    note: {
      type: String
    },
    closingNote: {
      type: String
    }
  },
  computed: {
    getPrice () {
      var price = '$' + this.price.toLocaleString()
      if (this.isRental) {
        price = price + ' / month'
      }
      return price
    },
    getSqft () {
      return this.sqft ? (this.sqft.toLocaleString() + ' sq ft') : ''
    },
    isRental () {
      return (this.price < 20000)
    },
    getTagline () {
      if (this.isRental) {
        return this.tagline.replace('Closed', 'Rented').replace('Active', 'For Rent')
      } else {
        return this.tagline.replace('Closed', 'Sold').replace('Active', 'For Sale')
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
